import moment from 'moment';
import { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

export const isNullOrEmpty = (value: any) => {
  return (
    value === null ||
    value === 'null' ||
    value === undefined ||
    value === '' ||
    value.length === 0 ||
    value === 'Invalid date' ||
    (typeof value === 'object' && Object.keys(value).length === 0)
  );
};

export const formatDate = (date: string | Date = '', showTime: boolean = false, format: string = 'DD/MM/YYYY'): string => {
  if (!date) {
    return '-';
  }

  const parsedDate = moment.utc(date);

  if (!parsedDate.isValid()) {
    return '-';
  }

  if (showTime) {
    return parsedDate.format('DD/MM/YYYY HH:mm');
  }
  return parsedDate.format(format);
};

export const formatDateTurkish = (date: string | Date | null | undefined = ''): string => {
  if (!date) {
    return '-';
  }

  const parsedDate = moment.utc(date);

  if (!parsedDate.isValid()) {
    return '-';
  }

  const turkishMonths = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

  const day = parsedDate.format('D');
  const month = turkishMonths[parsedDate.month()];
  const year = parsedDate.format('YYYY');
  const time = parsedDate.format('HH:mm');

  return `${day} ${month} ${year} ${time}`;
};

export const formatDateOnly = (date: string | Date | null | undefined = ''): string => {
  if (!date) {
    return '-';
  }

  const parsedDate = moment.utc(date);

  if (!parsedDate.isValid()) {
    return '-';
  }

  const turkishMonths = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

  const day = parsedDate.format('D');
  const month = turkishMonths[parsedDate.month()];
  const year = parsedDate.format('YYYY');

  return `${day} ${month} ${year}`;
};

export const extractImageUrl = (imageUrl: any): string => {
  if (!Array.isArray(imageUrl) || imageUrl.length === 0) return '';

  const firstLanguageData = imageUrl[0];
  if (!firstLanguageData || !firstLanguageData.documents || !Array.isArray(firstLanguageData.documents)) return '';

  const firstDocument = firstLanguageData.documents[0];
  return firstDocument?.publicUrl || '';
};

export const extractImageId = (imageUrl: any): number | null => {
  if (!Array.isArray(imageUrl) || imageUrl.length === 0) return null;

  const firstLanguageData = imageUrl[0];
  if (!firstLanguageData || !firstLanguageData.documents || !Array.isArray(firstLanguageData.documents)) return null;

  const firstDocument = firstLanguageData.documents[0];
  return firstDocument?.id || null;
};

export const countingNumberOfDays = (start: Dayjs, end: Dayjs): number => {
  if (!start || !end) return 0;
  return end.diff(start, 'day');
};

export function formatToSqlDate(date: Date | string) {
  if (typeof date === 'string') date = new Date(date);

  const year = date.getFullYear();

  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  const day = ('0' + date.getDate()).slice(-2);
  const hours = ('0' + date.getHours()).slice(-2);
  const minutes = ('0' + date.getMinutes()).slice(-2);
  const seconds = ('0' + date.getSeconds()).slice(-2);

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
}

export const disabledDate = (current: Dayjs | null) => {
  if (!current) return false;
  return current.isBefore(dayjs(), 'day');
};

export const disabledTime = (current: Dayjs | null) => {
  if (!current) return {};

  const now = dayjs();
  const isToday = current.isSame(now, 'day');

  if (!isToday) {
    return {};
  }

  const minTime = now.add(1, 'minute');
  const minHour = minTime.hour();
  const minMinute = minTime.minute();

  const disabledHours = () => {
    const hours = [];
    for (let i = 0; i < minHour; i++) {
      hours.push(i);
    }
    return hours;
  };

  const disabledMinutes = (selectedHour: number | null) => {
    if (selectedHour === null) return [];
    if (selectedHour < minHour) {
      return [];
    }
    if (selectedHour === minHour) {
      const minutes = [];
      for (let i = 0; i < minMinute; i++) {
        minutes.push(i);
      }
      return minutes;
    }
    return [];
  };

  return {
    disabledHours,
    disabledMinutes,
  };
};

export const disabledTimeWithMinutesOffset = (minutesOffset: number = 0) => {
  return (current: Dayjs | null) => {
    if (!current) return {};

    const now = dayjs();
    const isToday = current.isSame(now, 'day');

    if (!isToday) {
      return {};
    }

    const currentHour = now.hour();
    const currentMinute = now.minute();

    const disabledHours = () => {
      const hours = [];
      for (let i = 0; i < currentHour; i++) {
        hours.push(i);
      }
      return hours;
    };

    const disabledMinutes = (selectedHour: number | null) => {
      if (selectedHour === null) return [];
      if (selectedHour < currentHour) {
        return [];
      }
      if (selectedHour === currentHour) {
        const minutes = [];
        const minMinute = currentMinute - minutesOffset;
        for (let i = 0; i < minMinute; i++) {
          minutes.push(i);
        }
        return minutes;
      }
      return [];
    };

    return {
      disabledHours,
      disabledMinutes,
    };
  };
};
export const validateMaxLength = (value: string = '', maxLength: number, required?: boolean) => {
  value = (value + '').trim();

  if (required && !value) return false;

  return value.trim().length <= maxLength;
};

export const requiredValidate = (value: string) => {
  return value.trim().length < 1;
};

export const isValidEmail = (email: string): boolean => {
  if (!email) return false;
  const trimmedEmail = email.trim();
  if (!trimmedEmail) return false;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(trimmedEmail);
};

export const isValidHttpsUrl = (url: string): boolean => {
  if (!url || !url.trim()) {
    return false;
  }

  const trimmedUrl = url.trim();

  if (!trimmedUrl.startsWith('https://')) {
    return false;
  }

  try {
    const urlObj = new URL(trimmedUrl);

    if (urlObj.protocol !== 'https:') {
      return false;
    }

    if (!urlObj.hostname || urlObj.hostname.length === 0) {
      return false;
    }

    const hostnameRegex = /^([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
    if (!hostnameRegex.test(urlObj.hostname) && urlObj.hostname !== 'localhost') {
      return false;
    }

    return true;
  } catch {
    // URL constructor hata verirse geçersiz URL
    return false;
  }
};
